import { Injectable } from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';
import {CountedAndPaginated} from '../interface/response/counted-and-paginated';
import {Log} from '../interface/log';
import {first} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {CommissionSettlement} from "../interface/commission-settlement";

@Injectable({
  providedIn: 'root'
})
export class LogService {
  private readonly logListSubject: ReplaySubject<CountedAndPaginated<Log>> = new ReplaySubject<CountedAndPaginated<Log>>(1);

  constructor(
    private httpClient: HttpClient,
  ) {
  }

  public getLogListSubject(): ReplaySubject<CountedAndPaginated<Log>> {
    return this.logListSubject;
  }

  public loadPartnerLogList(partnerId: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/partner/${partnerId}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  public loadPartnerFacilityLogList(addressId: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/facility/${addressId}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loadOfwcaLogList(ofwcaUuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/ofwca/${ofwcaUuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loadDocumentLogList(documentId: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/document/${documentId}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loadNewsletterLogList(newsletterId: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/newsletter/${newsletterId}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loadContractLogList(contractId: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/contract/${contractId}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loadKrkLogList(krkId: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/krk/${krkId}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loadRegistrationLogList(registrationId: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/registration/${registrationId}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loadDeregistrationPackLogList(uuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/deregistrationPack/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loadIdentifierLogList(uuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/registration-id/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loadMeetingLogList(uuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/meeting/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loadCommissionRedirectionLogList(uuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/commission-redirection/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loadCommissionImportRowLogList(uuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/commission-import-row/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loadRegionalRowLogList(uuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/regional/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }
  loadInvoiceLogList(uuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/invoice/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }
  loadInsuranceCompanyLogList(id: number, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/insuranceCompany/${id}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }
  public getComissionContractLogDate(uuid: string, page: number, pageSize: number): Observable<Log>{
    return this.httpClient.get(`/rest/crm/commission-contract-settlement/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(first()) as Observable<Log>;

  }

  public getReceivablesBalanceRemindeLogDate(uuid: string, page: number, pageSize: number): Observable<Log>{
    return this.httpClient.get(`/rest/crm/receivables-balance/reminder/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(first()) as Observable<Log>;

  }

  public getComissionSettlementLogDate(uuid: string, page: number, pageSize: number): Observable<Log>{
    return this.httpClient.get(`/rest/crm/commission-settlement/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(first()) as Observable<Log>;

  }

  loadSupportLogList(uuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/support/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loadCorporationLogList(uuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/corporation/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }



  loadPost360LogList(uuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm360/asf24/post/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loadUserLogList(uuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/sso/user/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loagReceivablesPaymentImportRowLogList(uuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/receivables-payment-import-row/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loagReceivablesImportRowLogList(uuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/receivables-import-row/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loadIddTrainingTrainerLogList(uuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/idd-training-trainer/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }
  loadTemplateLogList(uuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/template/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loadReceivablesBalanceLogList(uuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/receivables-balance/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loadLicensedAgentLogList(uuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/licensed-agent/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loadTerminalsLogList(uuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/terminal/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }
  loadTerminalsImportRowsLogList(uuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/terminal-import-row/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loadAffiliateCodeLogList(uuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/affiliate-code/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loadPersonalDataChangeLogList(uuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/personalDataChange/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loadReceivablesTransferDataChangeLogList(uuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/receivables-transfer/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loadEmployeeDataChangeLogList(uuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/employee/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loadLeaveAPPlicationDataChangeLogList(uuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/leave-application/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loadHiperioRegistrationConfigLogList(id: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/hiperioRegistrationConfig/${id}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loadHiperioConfigDirectLogList(id: number, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/direct/hiperio-config-direct/${id}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }


  loadCommissionUpdatePackageLogList(uuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/commission-update-package/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loadLicenseLogList(uuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/license/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loadDeviceLogList(uuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/device/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loadWarehouseProductLogList(uuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/product/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loadAdditionalFieldLogList(uuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/additional-field/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loadCompetitionImportRowLogList(uuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/competition-import-row/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }

  loadCommissionTableLogList(uuid: string, page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/commission-table/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Log>) => {
        this.logListSubject.next(result);
      }, () => this.resetSubject());
  }
  loadRiskConfigurationLogList(
    uuid: string,
    page: number,
    pageSize: number
  ): void {
    this.httpClient
      .get(
        `/rest/crm/risk-configuration/${uuid}/log?page=${page + 1}&pageSize=${pageSize}`
      )
      .pipe(
        first()
      )
      .subscribe(
        (result: CountedAndPaginated<Log>) => {
          this.logListSubject.next(result);
        },
        () => this.resetSubject()
      );
  }

  private resetSubject(): void {
    this.logListSubject.next({items: [], pagination: {total: 0, pageSize: 0, thisPageSize: 0, currentPage: 1}});
  }

}
